import React from 'react';
import { Link } from 'react-router-dom';
import { siteConfig } from '../data/mock';
import { Mail, Phone, ExternalLink, Heart } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-stone-900 text-stone-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 md:gap-12">
          {/* Brand */}
          <div className="md:col-span-2">
            <img 
              src={siteConfig.logo} 
              alt="CRN Logo" 
              className="h-12 w-auto object-contain mb-4 brightness-0 invert opacity-90"
            />
            <p className="text-stone-400 text-sm leading-relaxed max-w-md mb-4">
              We are a network of health and hydration professionals dedicated to advancing recovery through cellular restoration. Helping people turn their recovery journey into purpose-driven businesses.
            </p>
            <p className="text-amber-400 text-sm italic">
              Healing Starts Within
            </p>
          </div>
          
          {/* Quick Links */}
          <div>
            <h4 className="text-white font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-stone-400 hover:text-amber-400 transition-colors text-sm">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/opportunity" className="text-stone-400 hover:text-amber-400 transition-colors text-sm">
                  The Opportunity
                </Link>
              </li>
              <li>
                <a 
                  href="https://crnnetwork.com" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-stone-400 hover:text-amber-400 transition-colors text-sm inline-flex items-center gap-1"
                >
                  CRN Network <ExternalLink className="w-3 h-3" />
                </a>
              </li>
            </ul>
          </div>
          
          {/* Contact */}
          <div>
            <h4 className="text-white font-semibold mb-4">Contact</h4>
            <ul className="space-y-3">
              <li>
                <a 
                  href={`mailto:${siteConfig.contact.email}`}
                  className="text-stone-400 hover:text-amber-400 transition-colors text-sm inline-flex items-center gap-2"
                >
                  <Mail className="w-4 h-4" />
                  {siteConfig.contact.email}
                </a>
              </li>
              <li>
                <a 
                  href={`tel:${siteConfig.contact.phone.replace(/\s/g, '')}`}
                  className="text-stone-400 hover:text-amber-400 transition-colors text-sm inline-flex items-center gap-2"
                >
                  <Phone className="w-4 h-4" />
                  {siteConfig.contact.phone}
                </a>
              </li>
            </ul>
          </div>
        </div>
        
        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-stone-800">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-stone-500 text-sm">
              © {new Date().getFullYear()} Cellular Recovery Network. All rights reserved.
            </p>
            <p className="text-stone-500 text-sm flex items-center gap-2">
              Made with <Heart className="w-4 h-4 text-amber-500 fill-amber-500" /> for those on the journey
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
